
define(
	'Tavanoteam.LocationInventory.LocationInventory'
	, [
		'Tavanoteam.LocationInventory.LocationInventory.View'
	]
	, function (
		LocationInventoryView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layoutComponent = container.getComponent('Layout');
				var pdpComponent = container.getComponent('PDP');

				if (layoutComponent) {
					layoutComponent.addChildView('Product.Options', function () {
						return new LocationInventoryView({ container: container });
					});
				}
			}
		};
	});
